/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import BookmarkItem from './BookmarkItem';
import styles from './index.less';
import { useBookmarkContext, useMoveSelectedBookmark } from './useBookmarkContext';
import Scrollbars from 'react-custom-scrollbars';

const BookmarkMenu = ({ contents, onSelectedChange }) => {
  const { selected, updateSelected } = useBookmarkContext();

  const handleChangeSelected = useCallback((item, bookmarkId) => {
    onSelectedChange?.(item);
    updateSelected({ _id: item?._id, bookmarkId });
  }, [onSelectedChange, updateSelected]);

  useMoveSelectedBookmark();

  return (
    <Scrollbars
      renderTrackHorizontal={ props => <div { ...props } style={ { display: 'none' } } className="track-horizontal" /> }
    >
      <ul className={ styles.bookmarksList }>
        {
          contents?.map(content =>
            !!content?.data?.length &&
            <BookmarkItem
              key={ `bookmark-item-${content?.title}` }
              { ...content }
              selected={ selected }
              onSelectedChange={ handleChangeSelected }
            />
          )
        }
      </ul>
    </Scrollbars>
  );
};

BookmarkMenu.propTypes = {
  contents: PropTypes.array,
  onSelectedChange: PropTypes.func
};

export default memo(BookmarkMenu);
